"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class CardModule extends base_1.SurveyModule {
    constructor(_a) {
        var { backgroundColor = "#FAFBFB", compact = false, image, modules = [], variant, url } = _a, rest = __rest(_a, ["backgroundColor", "compact", "image", "modules", "variant", "url"]);
        super(rest);
        this._type = "card";
        this.backgroundColor = backgroundColor;
        this.compact = compact;
        this.modules = modules;
        this.variant = variant;
        if (url) {
            if (!util_1.isValidUrl) {
                throw new Error(`invalid url given to card module constructor: ${url}`);
            }
            this._url = url;
        }
        if (image) {
            this.image = image;
        }
    }
    get url() {
        return this._url;
    }
    set url(url) {
        if (!!url && !(0, util_1.isValidUrl)(url)) {
            throw new Error(`invalid url given to card module: ${url}`);
        }
        this._url = url;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const builderConfigModule = {
                compact: this.compact,
                id: this.id,
                modules: this.modules.map((mod) => mod.toBuilderConfig()),
                variant: this.variant,
                type: this.type,
            };
            if (this.image) {
                builderConfigModule.image = this.image;
            }
            if (this.url) {
                builderConfigModule.url = this.url;
            }
            return builderConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            const surveyConfigModule = {
                actionRequired: this.actionRequired,
                compact: this.compact,
                id: this.id,
                modules: this.modules.flatMap((mod) => mod.toSurveyConfig()),
                variant: this.variant,
                type: this.type,
                style: this.style,
            };
            if (this.image) {
                surveyConfigModule.image = this.image;
            }
            if (this.url) {
                surveyConfigModule.url = this.url;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        return undefined;
    }
}
exports.CardModule = CardModule;
//# sourceMappingURL=Card.js.map